import { Component } from "react";
import { NavLink } from "react-router-dom";
import { ConfigContext } from "../../../Context/ConfigContext";
import { decodeData, decodeUrl, encodeData } from "../../../Constants/constants";

class UpdateEmployeeNavigationSideBar extends Component{
  static contextType = ConfigContext;
    constructor(props) {
      super(props);
      this.state = {
        encodedData: '',
        decodedDataId: '',
        decodedData: [],
      };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
          // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
              const queryParams = new URLSearchParams(window.location.search);
              const encodedData = queryParams.get("abs");
              const decodedDataId = decodeUrl(encodedData);
              console.log("decodedDataId",decodedDataId);
              const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
              console.log("decodedData",decodedData);
              if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({encodedData,decodedDataId, decodedData });
            }
            } else {
              console.warn("Permissions not yet available. Retrying...");
            }
        }
      }
    render () {
        const employee_id = this.props.employee_id;
        return <div className="col-lg-3">
        <div
          className="nav flex-column custom-nav nav-pills"
          role="tablist"
          aria-orientation="vertical"
        >
          <NavLink
            to={`/Employee/PersonalDetails/${employee_id}?abs=${encodeData(this.state.decodedDataId)}`}
            className="nav-link d-flex justify-content-start align-items-center"
            type="button"
            role="tab"
          
          >
            <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{
                textAlign: "left",
                marginLeft: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              Personal Details
            </span>
          </NavLink>

          <NavLink 
            to={`/Employee/LevelDetails/${employee_id}?abs=${encodeData(this.state.decodedDataId)}`}
            className="nav-link d-flex justify-content-start align-items-center"
            
            type="button"
            
          >
              <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{ textAlign: "left", marginLeft: "10px" }}
            >
              Salary Details
            </span>
          </NavLink>

          <NavLink
            to={`/Employee/FamilyDetails/${employee_id}?abs=${encodeData(this.state.decodedDataId)}`}
            className="nav-link d-flex justify-content-start align-items-center"
            type="button"
            
          >
              <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{ textAlign: "left", marginLeft: "10px" }}
            >
              Family Details
            </span>
          </NavLink>

          <NavLink 
            to={`/Employee/EducationalDetails/${employee_id}?abs=${encodeData(this.state.decodedDataId)}`}
            className="nav-link d-flex justify-content-start align-items-center"
            
            type="button"
           
          >
              <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{ textAlign: "left", marginLeft: "10px" }}
            >
              Educational Details
            </span>
          </NavLink>
          <NavLink 
            to={`/Employee/WorkExperience/${employee_id}?abs=${encodeData(this.state.decodedDataId)}`}
            className="nav-link d-flex justify-content-start align-items-center"
            
            type="button"
            
          >
              <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{ textAlign: "left", marginLeft: "10px" }}
            >
              Work Experience
            </span>
          </NavLink>
          <NavLink 
            to={`/Employee/BankDetails/${employee_id}?abs=${encodeData(this.state.decodedDataId)}`}
            className="nav-link d-flex justify-content-start align-items-center"
           
            type="button"
            role="tab"
            
          >
              <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{ textAlign: "left", marginLeft: "10px" }}
            >
              Bank Details
            </span>
          </NavLink>
          <NavLink 
            to={`/Employee/IdDetails/${employee_id}?abs=${encodeData(this.state.decodedDataId)}`}
            className="nav-link d-flex justify-content-start align-items-center"
            
            type="button"
           
          >
              <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{ textAlign: "left", marginLeft: "10px" }}
            >
              Documents  Details
            </span>
          </NavLink>

          <NavLink to={`/Employee/StatutoryDetails/${employee_id}?abs=${encodeData(this.state.decodedDataId)}`}
            className="nav-link d-flex justify-content-start align-items-center"
            type="button"
          >
              <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{ textAlign: "left", marginLeft: "10px" }}
            >
              Statutory Details
            </span>
          </NavLink>
          {/* <NavLink to="/SalaryDetails"
            className="nav-link d-flex justify-content-start align-items-center"
            id="v-pills-salarydetails-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-salarydetails"
            type="button"
            role="tab"
            aria-controls="v-pills-salarydetails"
            aria-selected="false"
          >
              <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />
            <span
              className="text-left"
              style={{ textAlign: "left", marginLeft: "10px" }}
            >
              Salary Details
            </span>
          </NavLink> */}
        </div>
        {/* end nav */}
      </div>
    }
}

export default UpdateEmployeeNavigationSideBar;